// src/lib/consent.js
// Zgoda na pliki cookie w jednym miejscu: zapis wyboru, odczyt i powiadamianie
// nasłuchujących (Google Consent Mode v2).
//
// Do czasu decyzji użytkownika zgody są ustawione na "denied", więc GA4
// i Google Ads nie zapisują nic w przeglądarce ani nie wysyłają identyfikatorów.

const STORAGE_KEY = 'pilotuje_cookie_consent';
const EVENT = 'pilotuje:consent';

/** 'granted' - wszystkie, 'denied' - tylko niezbędne, null - brak decyzji. */
export const readConsent = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (e) {
    // Tryb prywatny bez dostępu do localStorage - traktujemy jak brak decyzji.
    return null;
  }
};

export const saveConsent = value => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    /* brak zapisu to nie powód, żeby wywracać stronę */
  }
  applyConsent(value);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
};

// gtag.js czyta z dataLayer obiekty `arguments`, dlatego zgody wysyłamy
// dokładnie tak samo jak oficjalny snippet - przez funkcję opakowującą.
const gtag = function () {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
};

/** Przekazuje decyzję do gtag - działa też, gdy skrypt jeszcze się nie wczytał. */
export const applyConsent = value => {
  if (typeof window === 'undefined') return;
  const state = value === 'granted' ? 'granted' : 'denied';
  gtag('consent', 'update', {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
};

/** Domyślne odmowy - wywoływane zanim gtag.js zdąży cokolwiek zapisać. */
export const setDefaultConsent = () => {
  if (typeof window === 'undefined') return;
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
  });
};

export const onConsentChange = handler => {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};

export const CONSENT_EVENT = EVENT;
